'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaWifi = function FaWifi(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm19.9 32.2q-0.4 0-1.8-1.5t-1.4-1.8q0-0.6 1.2-1t2-0.4 2 0.4 1.2 1q0 0.4-1.4 1.8t-1.8 1.5z m5.2-5.3q0 0-0.8-0.5t-1.9-0.9-2.5-0.5-2.5 0.5-2 0.9-0.8 0.5q-0.3 0-1.8-1.4t-1.4-1.9q0-0.2 0.1-0.4 1.6-1.5 3.9-2.3t4.5-0.9 4.5 0.9 3.8 2.3q0.2 0.2 0.2 0.4 0 0.4-1.5 1.9t-1.8 1.4z m5.3-5.3q-0.2 0-0.4-0.1-2.7-2.1-4.9-3t-5.2-1q-1.7 0-3.3 0.4t-2.9 1.1-2.2 1.2-1.6 1-0.6 0.4q-0.3 0-1.7-1.4t-1.5-1.8q0-0.3 0.2-0.5 2.6-2.5 6.2-3.9t7.4-1.5 7.4 1.5 6.2 3.9q0.2 0.2 0.2 0.5 0 0.3-1.5 1.8t-1.8 1.4z m5.3-5.2q-0.2 0-0.5-0.2-3.4-3.1-7.2-4.6t-8.1-1.5-8.2 1.5-7.2 4.6q-0.2 0.2-0.4 0.2-0.4 0-1.8-1.5t-1.5-1.8q0-0.2 0.2-0.4 3.6-3.6 8.6-5.6t10.3-2 10.2 2 8.6 5.6q0.2 0.2 0.2 0.4 0 0.4-1.4 1.8t-1.8 1.5z' })
        )
    );
};

exports.default = FaWifi;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-icons/lib/fa/wifi.js
 ** module id = 1955
 ** module chunks = 0
 **/